import { Injectable } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { CompaniesComponent } from 'src/app/shared/companies/companies.component';
import { ModalConfig } from '../models/modalConfig';

@Injectable()
export class UibModalService {
    companiesModal!: BsModalRef;

    constructor(private bsModalService: BsModalService) { }

    showAllCompanies(): void {
        const config = new ModalConfig();
        config.class = 'custom-ngx-modal four-dot-five-modal-extra-small';
        config.ignoreBackdropClick = false;
        config.backdrop = true;
        this.companiesModal = this.bsModalService.show(CompaniesComponent, config);
    }

    closeCompaniesModal(): void {
        if (this.companiesModal) {
            this.companiesModal.hide();
        }
    }
}
